import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative flex items-center justify-center py-8 px-4 overflow-hidden bg-cream" data-id="element-240">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-6 items-center" data-id="element-241">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="order-2 lg:order-1 space-y-4" data-id="element-242">
          <div className="space-y-2" data-id="element-243">
            <span className="inline-block px-3 py-1 border border-terracotta/30 text-terracotta text-sm font-medium tracking-wider rounded-full uppercase" data-id="element-244">
              Para cuidadores
            </span>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-navy leading-tight" data-id="element-245">
              Cómo cuidar a tus padres{' '}
              <span className="text-terracotta italic" data-id="element-246">sin desaparecer</span> en
              el intento.
              <span className="block text-2xl md:text-3xl lg:text-4xl text-terracotta/80 font-semibold italic mt-2" data-id="element-247">
                (sin sentir culpa por poner límites)
              </span>
            </h1>
          </div>

          <div className="space-y-4 text-lg text-navy/80 leading-relaxed font-light" data-id="element-248">
            <p data-id="element-249">
              Hay un tipo de cansancio
              <br data-id="element-250" />
              que no se quita durmiendo.
            </p>
            <p data-id="element-251">Es el cansancio de vivir con una antena prendida 24/7:</p>
            <p data-id="element-252">
              ¿ya comió?
              <br data-id="element-253" />
              ¿ya tomó la medicina?
              <br data-id="element-254" />
              ¿y si se cae?
              <br data-id="element-255" />
              ¿y si se enoja?
              <br data-id="element-256" />
              ¿y si hoy toca cita?
              <br data-id="element-257" />
              ¿y si nadie más aparece?
            </p>
            <p data-id="element-258">Y lo peor no es solo lo que haces.</p>
            <p data-id="element-259">Es lo que no puedes decir.</p>
            <p data-id="element-260">
              Porque si dices "ya no puedo"…
              <br data-id="element-261" />
              te sientes mala persona.
            </p>
            <p data-id="element-262">
              Si pides ayuda,
              <br data-id="element-263" />
              te minimizan.
            </p>
            <p data-id="element-264">
              Y si pones límites…
              <br data-id="element-265" />
              te conviertes en "el/la egoísta" de la historia.
            </p>
            <p className="font-medium text-navy" data-id="element-266">
              Este libro es para cuando sientes que todo recae sobre ti…
            </p>
            <p className="font-medium text-navy" data-id="element-267">
              y por dentro ya no estás igual.
            </p>
          </div>

          <p className="text-base text-navy/60 italic" data-id="element-268">
            Si este momento ya llegó para ti, este mapa puede ayudarte.
          </p>

          <div className="pt-1 flex justify-center lg:justify-start" data-id="element-269">
            <a href="#comprar" className="inline-flex items-center justify-center px-8 py-4 bg-terracotta text-cream text-lg font-medium rounded-lg hover:bg-terracotta/90 transition-colors shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 duration-200" data-id="element-270">
              Ver el contenido del libro
            </a>
          </div>
        </motion.div>

        {/* Image Content */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.2,
        ease: 'easeOut'
      }} className="order-1 lg:order-2 flex flex-col items-center justify-center relative" data-id="element-271">
          <div className="relative w-full rounded-2xl shadow-2xl overflow-hidden" data-id="element-272">
            <img src="https://cdn.magicpatterns.com/uploads/8MTiUbonLxVxDXGFdwgCBL/1B2A4A_(3).png" alt="Bundle: Libro Cuando Todo Recae Sobre Ti + 5 Bonos Incluidos" className="w-full h-auto object-contain" data-id="element-273" />
          </div>
          <p className="text-center text-base text-navy/50 mt-6 leading-relaxed" data-id="element-274">
            Guía práctica (118 páginas)
            <br data-id="element-275" />
            para acompañarte sin desaparecer en el proceso
          </p>
        </motion.div>
      </div>
    </section>;
}